decorate.$inject = [ '$stateProvider' ];

/**
 * @param {StateProvider} $stateProvider
 */
export default function decorate($stateProvider) {

    $stateProvider.decorator('middleware', (state) => {

        if (state.parent && state.parent.middleware) {

            state.middleware = state.self.middleware = state.parent.middleware.concat(state.middleware || []);
        }

        return state.middleware;
    })
}



// WEBPACK FOOTER //
// ./src/middleware/middleware.decorate.js